export const RjsfSubmitButton = (isSubmitting = false) => ({
    "ui:submitButtonOptions": {
        "submitText": "Save",
        "norender": false,
        "props": {
            "className": "button button--primary button--blue",
            "isLoading": isSubmitting,
            "disabled": isSubmitting,
            "loadingText": "Saving..",
            "colorScheme": "blue"
        }
    }
})